import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

export default class extends Controller {
  static targets = ["toast", "anchor"];
  static values = { durationSeconds: { type: Number, default: 3 } };

  show() {
    if (this.anchorOnScreen) return;

    clearTimeout(this.hideTimer);
    enter(this.toastTarget);
    this.hideTimer = setTimeout(
      () => leave(this.toastTarget),
      this.durationSecondsValue * 1000,
    );
  }

  disconnect() {
    clearTimeout(this.hideTimer);
  }

  get anchorOnScreen() {
    const { top, bottom } = this.anchorTarget.getBoundingClientRect();
    return top < window.innerHeight && bottom > 0;
  }
}
